const hasWindow = () => typeof window !== 'undefined'

export const hasIntersectionObserver = () =>
  hasWindow() &&
  typeof window.IntersectionObserver === 'function' &&
  typeof window.IntersectionObserverEntry === 'function' &&
  'isIntersecting' in window.IntersectionObserverEntry.prototype

export const hasResizeObserver = () =>
  hasWindow() && typeof window.ResizeObserver === 'function'

export const hasWebAnimations = () =>
  hasWindow() &&
  typeof window.Element === 'function' &&
  typeof window.Element.prototype.animate === 'function'

export const prefersReducedMotion = () =>
  hasWindow() &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

export const scrollBehavior = () => (prefersReducedMotion() ? 'auto' : 'smooth')
